import { useState, useEffect } from 'preact/hooks';

interface MessageProps {
  text: string;
  type: 'success' | 'error';
  onDismiss?: () => void;
}

export function Message({ text, type, onDismiss }: MessageProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onDismiss?.();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  if (!visible) return null;

  return (
    <div class={`msg msg-${type}`}>
      {text}
    </div>
  );
}
